// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"d05f75e8","256":"618f7985","468":"d1cbbb06","476":"fa8778c8","581":"0fca7399","652":"683efd44","676":"9cf3a804","848":"9cf3a804"}[chunkId] + ".chunk.css";
};